import React from "react";

function EventIcon({
  className,
  style,
}: {
  className?: string;
  style?: object;
}) {
  return (
    <svg viewBox="0 0 17.968 16.586" className={className} style={style}>
      <g transform="translate(-3.375 -4.5)">
        <path
          d="M19.615,6.75H17.888V7.787a.347.347,0,0,1-.346.346h-.691a.347.347,0,0,1-.346-.346V6.75H8.213V7.787a.347.347,0,0,1-.346.346H7.176a.347.347,0,0,1-.346-.346V6.75H5.1A1.733,1.733,0,0,0,3.375,8.478V20.226A1.733,1.733,0,0,0,5.1,21.954H19.615a1.733,1.733,0,0,0,1.728-1.728V8.478A1.733,1.733,0,0,0,19.615,6.75Zm.346,12.958a.866.866,0,0,1-.864.864H5.621a.866.866,0,0,1-.864-.864V11.933a.347.347,0,0,1,.346-.346H19.615a.347.347,0,0,1,.346.346Z"
          transform="translate(0 -0.868)"
        />
        <path
          d="M10.382,4.846a.347.347,0,0,0-.346-.346H9.346A.347.347,0,0,0,9,4.846V5.882h1.382Z"
          transform="translate(-2.17)"
        />
        <path
          d="M26.132,4.846a.347.347,0,0,0-.346-.346H25.1a.347.347,0,0,0-.346.346V5.882h1.382Z"
          transform="translate(-8.244)"
        />
      </g>
    </svg>
  );
}

export { EventIcon };
